import React, { FC } from 'react';
import { Order } from 'src/interfaces/Table';
import deliveryOrdersState from 'src/recoil/atoms/deliveryOrders';
import DeliveryOrder from 'src/interfaces/api/DeliveryOrder';
import EntityTable from 'src/components/Table/EntityTable.container';
import { TableColumn } from 'src/components/Table/EntityTable';
import { CollectionResponse } from 'src/interfaces/api/api';
import useScreenBreakpoint from 'src/hooks/useMediaQuery';
import Badge from 'src/components/Badge';

interface Props {
  onGetDeliveryOrders: (
    page: number,
    limit: number,
    orderBy: keyof DeliveryOrder,
    order: Order
  ) => Promise<CollectionResponse<DeliveryOrder>>;
}

const badgeStyle = { marginRight: 5, marginBottom: 5 };

const columns: TableColumn<DeliveryOrder>[] = [
  {
    id: 'socialReason',
    type: 'text',
    label: 'Comptes',
    link: (deliveryOrder: DeliveryOrder) => `/dashboard/delivery-orders/${deliveryOrder.id}`,
  },
  {
    id: 'partialDelivery',
    type: 'text',
    label: 'Statut',
    renderValue: (deliveryOrder: DeliveryOrder) => (
      <div>
        {deliveryOrder.partialDelivery ? (
          <Badge style={badgeStyle} color='warning' text='Partielle' />
        ) : (
          <Badge style={badgeStyle} color='primary' text='Complet' />
        )}
        {deliveryOrder.hasSurplus && <Badge style={badgeStyle} color='error' text='A facturer' />}
      </div>
    ),
  },
  {
    id: 'createdAt',
    type: 'datetime',
    label: 'Crée le',
    sortable: true,
    link: (deliveryOrder: DeliveryOrder) => `/dashboard/delivery-orders/${deliveryOrder.id}`,
  },
];

const DeliveryOrderTable: FC<Props> = ({ onGetDeliveryOrders }) => {
  const screenBreakPoint = useScreenBreakpoint();

  return (
    <EntityTable
      columns={columns}
      defaultOrderBy='createdAt'
      atomState={deliveryOrdersState}
      fetchEntitiesCallback={onGetDeliveryOrders}
      labelRowsPerPage={['xs', 'md'].includes(screenBreakPoint) ? ' ' : 'Element par page: '}
      labelDisplayedRows={
        ['xs', 'md'].includes(screenBreakPoint) ? ({ from, to, count }) => `${from}-${to}` : undefined
      }
    />
  );
};

export default React.memo(DeliveryOrderTable);
